export function toTitleCase(value: string) {
  return value.replace(/([A-Z])/g, " $1");
}
